import _ from 'lodash';

import {
  EVENT_TEMPLATE_TYPE,
  RETENTION_TEMPLATE_TYPE,
  USER_TEMPLATE_TYPE,
} from '../../constants/dashboards';

const initialState = {
  dashboards: [],
  templates: {},
};

const fetch = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_DASHBOARDS_SUCCESS':
      return {
        ...state,
        dashboards: action.dashboards,
      };

    case 'SAVE_DASHBOARD_SUCCESS':
      return {
        ...state,
        dashboards: [...state.dashboards, action.dashboard],
      };

    case 'CREATE_DASHBOARD_SUCCESS':
    case 'UPDATE_DASHBOARD_SUCCESS': {
      const dashboardIndex = state.dashboards.findIndex((d) => d.id === action.dashboard.id);
      const newDashboards = state.dashboards;

      newDashboards.splice(dashboardIndex, 1, action.dashboard);

      return {
        ...state,
        dashboards: newDashboards,
      };
    }

    case `CREATE_TEMPLATE_${EVENT_TEMPLATE_TYPE}_SUCCESS`:
    case `CREATE_TEMPLATE_${RETENTION_TEMPLATE_TYPE}_SUCCESS`:
    case `CREATE_TEMPLATE_${USER_TEMPLATE_TYPE}_SUCCESS`:
      return {
        ...state,
        templates: {
          ...state.templates,
          [action.template.id]: action.template,
        },
      };

    case 'FETCH_TEMPLATES_SUCCESS':
      return {
        ...state,
        templates: action.templates,
      };

    case 'UPDATE_TEMPLATE_SUCCESS':
      return {
        ...state,
        templates: {
          ...state.templates,
          [action.template.id]: action.template,
        },
      };

    case 'DELETE_TEMPLATE_SUCCESS':
      return {
        ...state,
        templates: _.omit(state.templates, action.id),
      };

    case 'DELETE_DASHBOARD_SUCCESS':
      return {
        ...state,
        dashboards: state.dashboards.filter((dashboard) => dashboard.id !== action.id),
      };

    default:
      return state;
  }
};

export default fetch;

export const getTemplates = (state) => state.templates;

export const getDashboards = (state) => state.dashboards;
